module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-04.55eb41b.jpg";